@if (showWidget()) {
  <div id="image-card-widget-display-area">
    <div
      id="image-card-widget-drop-area"
      #dropArea
      cdkDropList
      cdkDropListSortingDisabled="true"
      (cdkDropListDropped)="handleDrop($event)">
      <topo-image-card
        [style.pointerEvents]="state.isMapInWorkbenchMode() ? 'all' : 'none'"
        [settings]="settings()"
        (dragReleased)="onDragReleased()"
        dragBoundary="#image-card-widget-drop-area"
        [parentContainerRect]="dropAreaRect()" />
    </div>
  </div>
}
